<template>
  <div class="analysis-card" @click="goToActor">
    <div class="actor-top-section">
      <ActorAvatar
        class="actor-avatar"
        :actor-logo-url="actor.photoUrl || actor.photo_url"
        :actor="actor"
        :width="50"
        variant="rounded"
      />
      <div style="display: flex; flex-direction: column; text-align: left; place-self: end;">
        <span class="actor-name"><strong>{{ actor.name }}</strong></span>
      </div>
    </div>
    <div class="actor-details">
      <span class="actor-address" v-if="actor.address && actor.address.city && actor.address.country">Based in <strong>{{ actor.address.city }}, {{
          actor.address.country
        }}</strong></span>
      <span class="actor-founding-date" v-if="actor.founding_date">Is founded on <strong>{{ actor.founding_date }}</strong></span>
    </div>
    <div class="actor-analysis-description">
      <p v-html="actor.description"></p>
    </div>
    <div class="actor-analysis-actions">
      <DsButton
        v-if="actor.isActorClaimed"
        size="small"
        variant="rounded"
        :icon="!actor.hasInviteesAttached ? 'email-outline' : 'email'"
        icon-fill-color="white"
        :loading="addingInvitees"
        v-tooltip="actor.hasInviteesAttached ? invitationsAttachedToolTip : invitationToolTip"
        @click.stop="inviteUsersWithClaimOnActorToChallenge"
      />
      <DsButton
        size="small"
        variant="rounded"
        :icon="actor.isActorShortListed ? 'star' : 'star-outline'"
        icon-fill-color="white"
        :loading="loading"
        @click.stop="$emit('toggle-shortlist-status', actor)"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import ActorAvatar from '@/Domain/Actor/Components/ActorAvatar.vue'
  import { inviteUsersViaActor } from '@/Domain/Challenge/Api/challenges'
  import TranslationsMixin from '@/util/TranslationsMixin'

  export default {
    name: "ActorSuggestionCardNew",
    mixins: [TranslationsMixin],
    emits: ['toggle-shortlist-status', 'manage-invitees'],
    props: {
      actor: {
        type: Object,
        default: () => {
          return {}
        },
      },
      suggestion: {
        type: Object,
        default: () => {
          return {}
        },
      },
      processingSuggestion: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        value: {},
        errors: [],
        state: false,
        status: false,
        addingInvitees: false,
      }
    },
    methods: {
      goToActor() {
        window.open(window.location.origin + '/actors/' + this.actor.id, '_blank')
      },
      inviteUsersWithClaimOnActorToChallenge() {
        if (this.actor.loadingInvitees) {
          return
        }

        if (this.actor.hasInviteesAttached) {
          this.$emit('manage-invitees')

          return
        }

        this.addingInvitees = true

        // hack to reload icon name
        this.componentKey++

        inviteUsersViaActor(this.challengeId, this.actor.id)
          .then(() => {
            this.$bus.emit('challengeInviteesUpdated', this.actor.id)
            this.$bus.emit('challengeInviteesInvited', this.actor.id)
            this.actor.hasInviteesAttached = true
            this.addingInvitees = false
          })
          .catch((error) => {
            this.addingInvitees = false
          })
      },
      /*approveActorSuggestion () {
        this.$emit('approve')
      },
      approveSuggestion () {
        if (this.actor && this.actor.id) {
          return this.approveActorSuggestion()
        }
      },
      denySuggestion () {
        this.$emit('deny', true)
      },*/
    },
    computed: {
      config() {
        return this.$store.state.config
      },
      challengeId(): Number {
        return Number(this.$route.params.id)
      },
      invitationToolTip(): string {
        return `Invite users linked to the actor to this ${this.challengeLabel}`
      },
      invitationsAttachedToolTip(): string {
        return `Users linked to the actor have been invited to this ${this.challengeLabel}`
      }
    },
    components: { ActorAvatar },
  }
</script>

<style lang="scss" scoped>
  @import "../../../../scss/variables.scss";

  .analysis-card {
    border: 2px solid $color-borders;
    border-radius: $default-border-radius-narrow;
    position: relative;
    cursor: pointer;
    word-break: break-word;
    height: auto;
    padding: 1rem;

    .actor-analysis-description {
      word-break: break-word;
      -webkit-line-clamp: 5;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      height: 100px;
    }

    .actor-top-section {
      display: flex;
      flex-direction: row;
      height: 50px;

      .actor-avatar {
        width: 50px;
        height: 50px;
        border: 1px solid lightgrey;
        border-radius: 5px;
        justify-self: start;
      }

      .actor-name {
        margin-top: 0.5rem;
        justify-self: end;
        place-self: end;
      }
    }


    .actor-details {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      display: flex;
      flex-direction: column;
      height: 30px;

      .actor-address {
        font-size: 11px;
      }

      .actor-founding-date {
        font-size: 11px;
      }
    }

    .actor-analysis-actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-top: 0.5rem;
    }

  }
</style>
